import { Button } from '@/components/base/button';
import { PageHeading } from '@/components/base/page-heading';

import { Link } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';

const items = {
  MLM: {
    title: 'sideDescriptionNetworkRegister.mlm.title',
    description: [
      'sideDescriptionNetworkRegister.mlm.description',
      'sideDescriptionNetworkRegister.mlm.description1',
      'sideDescriptionNetworkRegister.mlm.description2',
      'sideDescriptionNetworkRegister.mlm.description3',
    ],
    pdf: 'https://monevis-cdn.s3.eu-central-1.amazonaws.com/Monevis_Affiliate_2025.pdf',
    navigate: '/auth/registration?network=1',
    buttonText: 'sideDescriptionNetworkRegister.mlm.buttonText',
    image: '/images/mlm-illustration.png',
    label: 'sideDescriptionNetworkRegister.mlm.label',
  },
  AFFILIATE: {
    title: 'sideDescriptionNetworkRegister.affiliate.title',
    description: [
      'sideDescriptionNetworkRegister.affiliate.description',
      'sideDescriptionNetworkRegister.affiliate.description1',
      'sideDescriptionNetworkRegister.affiliate.description2',
      'sideDescriptionNetworkRegister.affiliate.description3',
      'sideDescriptionNetworkRegister.affiliate.description4',
    ],
    pdf: 'https://monevis-cdn.s3.eu-central-1.amazonaws.com/Monevis_Influencers_2025.pdf',
    navigate: '/auth/registration?network=2',
    buttonText: 'sideDescriptionNetworkRegister.affiliate.buttonText',
    image: '/images/affiliate-illustration.png',
    label: 'sideDescriptionNetworkRegister.affiliate.label',
  },
};

export function NetworkRegistration(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="mt-16 flex flex-col gap-8 rounded-lg p-4">
      <PageHeading
        size="xxlarge"
        className="text-center text-4xl dark:text-white"
        subheadingClassName="text-center"
        subheading={t('sideDescriptionNetworkRegister.description')}
      >
        {t('sideDescriptionNetworkRegister.title')}
      </PageHeading>

      <div className="relative grid grid-cols-1 gap-10 md:grid-cols-2">
        {Object.entries(items).map(([key, item]) => (
          <div key={key} className="flex flex-col gap-5">
            <div className="group relative z-10 flex h-full w-full flex-col justify-between gap-5 overflow-hidden rounded-lg border border-white/10 bg-slate-950/50 px-8 py-5 text-white backdrop-blur-md md:max-w-[500px]">
              <div>
                <Link href={item.navigate}>
                  <div className="relative z-10 flex flex-col gap-8">
                    <div className="relative mx-auto hidden h-fit w-fit rounded-[4px] border border-white/15 bg-white/5 px-3 py-1 text-white shadow-bottom-white sm:block">
                      <div className="absolute -top-px left-1/2 z-20 mx-auto h-px w-1/2 -translate-x-1/2 bg-gradient-to-r from-transparent via-blue-600 to-transparent" />
                      <span className="flex w-full whitespace-nowrap text-sm font-bold">
                        {t(item.label)}
                      </span>
                    </div>

                    <img
                      alt="illustration"
                      src={item.image}
                      className="mx-auto h-auto max-h-[125px] w-fit"
                    />
                    <div className="flex flex-col items-center justify-center gap-3">
                      <div className="flex w-full items-center justify-between">
                        <PageHeading
                          size="default"
                          className="text-center dark:text-white"
                        >
                          {t(item.title)}
                        </PageHeading>
                      </div>

                      <ul className="flex list-disc flex-col gap-2 text-gray-300">
                        {item.description.map((desc, index) => (
                          <li key={index} className="text-sm">
                            <Trans
                              components={{
                                1: <span className="font-bold text-white" />,
                              }}
                              i18nKey={desc}
                            />
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </Link>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={item.pdf}
                  className="z-[70] mt-2 flex items-center justify-center py-2 font-light text-blue-400 underline underline-offset-2"
                >
                  {t('sideDescriptionNetworkRegister.pdfButton')}
                </a>
              </div>
              <Link className="md:mx-auto" to={item.navigate}>
                <Button className="w-full md:w-fit">
                  {t(item.buttonText)}
                </Button>
              </Link>
            </div>
          </div>
        ))}
      </div>
      <img
        alt="shape illustration"
        className="absolute left-0 top-0 -z-10 hidden max-w-[450px] -translate-x-1/2 md:block"
        src="/images/liquid-3.webp"
      />
      <img
        alt="shape illustration"
        className="absolute bottom-0 right-0 -z-10 hidden max-w-[450px] translate-x-1/2 md:block"
        src="/images/liquid-4.webp"
      />
    </div>
  );
}
